import { Component, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { Subscription } from 'rxjs';

import { SharedDataService } from '../../services/shared-data.service';
import { DropdownObjectType } from '../../shared/types';
import { ButtonComponent } from '../button/button.component';
import { TIMEZONE_LIST } from '../../shared/constant';
import { OutsideClickDirective } from '../../directives/outside-click.directive';

@Component({
  selector: 'timezone',
  standalone: true,
  imports: [CommonModule, MatMenuModule, ButtonComponent, OutsideClickDirective],
  templateUrl: './timezone.component.html',
  styleUrl: './timezone.component.scss',
})
export class TimezoneComponent implements OnInit, OnDestroy {
  constructor(private sharedDataService: SharedDataService) {}
  /** When true, dropdown opens upward (e.g. for NOVA input at bottom of screen). */
  @Input() openUpward: boolean = false;
  selectedValue: DropdownObjectType | undefined | null = { label: 'EST', value: 'EST' };
  protected _dropdownOpened = signal<boolean>(false);
  contentList: Array<DropdownObjectType> = TIMEZONE_LIST;
  private timezoneChangeSub?: Subscription;

  ngOnInit() {
    if (this.openUpward) {
      // NOVA: sync displayed timezone from shared service (set when conversation context is applied)
      const current = this.sharedDataService.selectedTimezoneValue;
      const match = this.contentList.find((t) => t.value === current);
      if (match) this.selectedValue = match;
      this.timezoneChangeSub = this.sharedDataService.getTimezoneChange().subscribe((value) => {
        const item = this.contentList.find((t) => t.value === value);
        if (item) this.selectedValue = item;
      });
      return;
    }
    this.sharedDataService.getToggleValues().subscribe((values) => {
      this._dropdownOpened.set(values.timeZone);
    });
  }

  ngOnDestroy() {
    this.timezoneChangeSub?.unsubscribe();
  }

  handleItemSelect = (event: MouseEvent, item: DropdownObjectType) => {
    if (!this.openUpward) {
      this.sharedDataService.toggleTimeZone(false);
    } else {
      this._dropdownOpened.set(false);
    }
    this.selectedValue = item;
    this.sharedDataService.setSelectedTimezoneValue(item.value);
  };

  onOutsideClick = () => {
    if (this.openUpward) {
      this._dropdownOpened.set(false);
    } else {
      this.sharedDataService.toggleTimeZone(false);
    }
  };

  handleButtonClick = () => {
    if (this.openUpward) {
      this._dropdownOpened.update((v) => !v);
    } else {
      this.sharedDataService.toggleTimeZone(!this._dropdownOpened());
    }
  };
}
